import { useState, useEffect } from 'react';
import { subscribe, unsubscribe } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { MB_OPEN_BETS_TOPIC } from '../consts';
export const usePlacedBets = () => {
    const [placedBets, setPlacedBets] = useState([]);
    useEffect(() => {
        const token = subscribe(MB_OPEN_BETS_TOPIC, (t, v) => {
            if (!v.error) {
                const placedBets = Object.values(v)
                    .map((data) => data.supportingData.outcomes.map((event) => event.outcomeRef.replace('OB_OU', '')))
                    .filter(Boolean)
                    .reduce((acc, val) => acc.concat(val), []);
                setPlacedBets(placedBets);
            }
        });
        return () => unsubscribe(token);
    }, []);
    return placedBets;
};
